/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from 'react';
import { Switch, Route, Redirect, useParams } from 'react-router-dom';
import { connect } from 'react-redux';

// project imports
import {
    PersonalInfo,
    ChangePassword,
    TaxExemptions,
    NotificationPreferences,
    InvoiceList,
    InvoiceView,
    PaymentMethodsList,
    PaymentMethodsAdd,
    PersonalInterest,
    ThankYou,
    InvoiceRaView,
    InvoiceGdView,
    
} from 'features/components/base/auth-pages/MyAccount';
import DeleteAccount from 'features/components/base/auth-pages/MyAccount/delete-account/DeleteAccount';
import AuctionSPSale from 'features/components/calendar/AuctionSPSale';
import WorthPoint from 'features/components/calendar/membership-benefits/worthpoint';
import Mir from 'features/components/base/auth-pages/MyAccount/mir/Mir';
import GuranteedDelivery from 'features/components/calendar/membership-benefits/guaranteedDelivery';
import AlzheimersFoundation from 'features/components/calendar/membership-benefits/AlzheimersFoundation';
import MemberService from 'features/components/calendar/membership-benefits/MemberService';
import MyPrimerAccount from 'features/components/calendar/membership-benefits/MyPrimerAccount';
import PremierFaqs from 'features/components/calendar/membership-benefits/PremierFaqs';
import PMAdvisor from 'features/components/calendar/membership-benefits/PMAdvisor';
import AuctionSPSItems from 'features/components/calendar/AuctionSPSItems';
import AuctionSPSItem from 'features/components/calendar/AuctionSPSItem';
import VipPlan from 'features/components/base/auth-pages/MyAccount/vip-member/VipPlan';
import DG from 'features/components/base/auth-pages/MyAccount/DG/DG';
import ShippedItems from 'features/components/base/auth-pages/MyAccount/invoice/ShippedItems';
import MembershipThankYou from 'features/components/calendar/membership-benefits/MembershipThankYou';
import AutoRenew from 'features/components/calendar/membership-benefits/AutoRenew';
import PremierMemberInvoiceView from 'features/components/calendar/membership-benefits/PremierMemberInvoiceView';
import CtbidsThankYou from 'features/components/calendar/membership-benefits/CtbidsThankYou';
import BecomeaPm from 'features/components/base/auth-pages/MyAccount/vip-member/BecomeaPm';
/**
 * routing for my-account components
 * 
 * @param props
 * 
 * @return routing for buyers components
 * 
**/

const InvoiceRenderFn = (props) => {
    const params = useParams();
    return <InvoiceView key={params.invoiceId} {...props} />
}
class MyAccountRouter extends Component {

    validateMembership = (RenderComponent) => {
        if ( this.props?.user?.membershipCompleted === 1 ) {
            return <RenderComponent {...this.props} />
        } else {
            return <Redirect to="/my-account/join-premier-member" />
        }
    }

    validateSuspension = (RenderComponent) => {
        if ( this.props?.user.suspensionstatus != "ALL" ) {
            return <RenderComponent {...this.props} />
        } else {
            return <Redirect to="/" />
        }
    }

    render() {
        return (
            <Switch>
                <Route exact path={`/my-account/my-info/personal-info`} component={PersonalInfo} />
                <Route exact path={`/my-account/ctbids/thankyou`} component={CtbidsThankYou} />
                <Route exact path={`/my-account/join-premier-member`} component={BecomeaPm} />
                <Route exact path={`/my-account/my-info/personal-interests`} component={PersonalInterest} />
                <Route exact path={`/my-account/my-info/thank-you`} component={ThankYou} />
                <Route exact path={`/my-account/my-info/delete-account`} component={DeleteAccount} />
                <Route exact path={`/my-account/my-info/change-password`} component={ChangePassword} />
                <Route exact path={`/my-account/my-info/tax-exemptions`} component={TaxExemptions} />
                <Route exact path={`/my-account/my-info/payment-methods`} component={PaymentMethodsList} />
                <Route exact path={`/my-account/my-info/payment-methods/add`} component={PaymentMethodsAdd} />
                <Route exact path={`/my-account/notification-preferences`} component={NotificationPreferences} />
                <Route exact path={`/my-account/invoice`} component={InvoiceList} />
                <Route exact path={`/my-account/invoice/:invoiceId/view`} component={InvoiceRenderFn} />
                <Route exact path={`/my-account/invoice/ra/:invoiceId/view`} component={InvoiceRaView} />
                <Route exact path={`/my-account/invoice/dg/:invoiceId/view`} component={InvoiceGdView} />
                <Route exact path={`/my-account/invoice/shipped-items`} component={ShippedItems} />
                <Route exact path={`/my-account/mir`} component={Mir} />
                <Route exact path={`/my-account/gd`} component={DG} />
                <Route exact path={`/my-account/premier-plan`} component={VipPlan} />

                <Route exact path={`/my-account/premier/member-benefits`} render={() => this.validateMembership(MemberService)} />
                <Route exact path={`/my-account/premier/auction-sneak-peak`} render={() => this.validateMembership(AuctionSPSale)} />
                <Route exact path={`/my-account/premier/auction-sneak-peak-sale/:saleId`} render={() => this.validateMembership(AuctionSPSItems)} />
                <Route exact path={`/my-account/premier/auction-sneak-peak-item/:saleId/item/:itemId`} render={() => this.validateMembership(AuctionSPSItem)} />
                <Route exact path={`/my-account/premier/delivery-guarantee`} render={() => this.validateMembership(GuranteedDelivery)} />
                <Route exact path={`/my-account/premier/alzheimers-foundation`} render={() => this.validateMembership(AlzheimersFoundation)} />
                <Route exact path={`/my-account/premier/premier-membership`} render={() => this.validateMembership(MemberService)} />
                <Route exact path={`/my-account/premier/premier-account`} render={() => this.validateMembership(MyPrimerAccount)} />
                <Route exact path={`/my-account/premier/advisor`} render={() => this.validateMembership(PMAdvisor)} />
                <Route exact path={`/my-account/premier/total-access`} render={() => this.validateMembership(PremierFaqs)} />
                <Route exact path={`/my-account/premier-member/invoice/view`} render={() => this.validateMembership(PremierMemberInvoiceView)} />
                <Route exact path={`/my-account/premier/worthpoint`} render={() => this.validateMembership(WorthPoint)} />
                <Route exact path={`/my-account/premier/thankyou`} render={() => this.validateMembership(MembershipThankYou)} />
                <Route exact path="/my-account/autorenew" render={() => this.validateSuspension(AutoRenew)} />
                <Redirect to="/" />
            </Switch>
        );
    }
}
export default connect(state => state)(MyAccountRouter);